import pluralizeStringUtil from 'utils/string/plurialize/index.js'

/**
 * @param exerciseName
 * @returns {string}
 */
export default function getExerciseNamePluralExerciseUtil (exerciseName) {
  let exerciseNamePlural = ''

  if (!exerciseName) {
    return exerciseNamePlural
  }

  const words = exerciseName.split(' ')
  let lastWord = words[words.length - 1]
  // Pluralize exercise name with parentheses
  if (lastWord[lastWord.length - 1] === ')') {
    const splitWordsFromOpeningParenthese = exerciseName.split(' (')
    const wordsBeforeOpeningParenthese = splitWordsFromOpeningParenthese[0].split(' ')
    lastWord = wordsBeforeOpeningParenthese[wordsBeforeOpeningParenthese.length -
    1]
    const plural = pluralizeStringUtil(lastWord)
    wordsBeforeOpeningParenthese.map((word, index) => {
      if (index === wordsBeforeOpeningParenthese.length - 1) {
        exerciseNamePlural = exerciseNamePlural + ` ${plural}`
      } else {
        exerciseNamePlural = exerciseNamePlural + ` ${word}`
      }
      return null
    })
    return exerciseNamePlural + ` (${splitWordsFromOpeningParenthese[1]}`
  }

  // Pluralize exercise name without parentheses
  const plural = pluralizeStringUtil(lastWord)
  words.forEach((word, index) => {
    if (index === words.length - 1) {
      exerciseNamePlural = exerciseNamePlural + ` ${plural}`
    } else {
      exerciseNamePlural = exerciseNamePlural + ` ${word}`
    }
    return null
  })

  return exerciseNamePlural
}
